import * as React from "react";
import { useState } from "react";
import IdleTimer from "react-idle-timer";
import { Logout } from "../logout/index";
import Props from "./types";
import { Timer } from "src/pages/auth/Login/Timer";
import ModalView from "src/presentations/views/ModalView";


export const InactivityDetector: React.FC<any> = (
  props: Props,
): JSX.Element => {

  const [isOpen, setisOpen] = useState(false);
  
  const handleOnIdle = () => {
    if (localStorage.getItem("meCurrent")) {
      setisOpen(true);
    }
  }

  const setstatus = (value: string) => {
    localStorage.setItem('timer', value);
  }

  const header = <span>Warning</span>;

  const finish = () => {
    setstatus('true');
    if (isOpen) {
      Logout.logout();
      window.location.href = '/en/signin';
    }
  }


  const displayContent = (
    <div >
      <span>
        Your account will be logout in <Timer time={30} onfinish={finish} />
      </span>
      <div className="cancel-btn-box">
        <button className="cancel-button" onClick={() => setisOpen(true)}>Cancel</button>
      </div>
    </div>
  );

  const active = () => {
    setisOpen(false);
    const timerstatus = localStorage.getItem('timer');
    if (timerstatus === 'true') {
      setstatus('false');
      Logout.logout();
      window.location.href = '/en/signin';
    }
  };

  return (
    <>
      {process.env.REACT_APP_TRACK_STATUS === "true" && (
        <div>
          <ModalView
            show={isOpen}
            bsSize={"small"}
            dialogClassName={"modalClient"}
            header={header}
            content={displayContent}
          />
          <IdleTimer
            timeout={2 * 60 * 60 * 1000}
            onIdle={handleOnIdle}
            onActive={active}
            crossTab={{
              emitOnAllTabs: true,
            }}
            startOnMount={true}
            debounce={60 * 1000}
          />
        </div>
      )}

      <style>
        {
          `
        .cancel-button{
          background-color: #086AD8;
          color: rgb(255, 255, 255);
          padding: 5px 10px;
          font-weight: bold;
          border-radius: 2px;
          margin-top: 20px;
          font-size: 13px;
          border:none;
        }
        .cancel-btn-box{
          display: flex;
          justify-content: end;
        }
        .modal-body span {
          font-size:17px;
        }
      
        .modal-header span{
          font-weight:bold;
        }
        `
        }
      </style>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/utils/InactivityDetector/index.tsx